import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisTrendChartResponseDto,
  IAnalysisTrendChartResultVo,
  TAnalysisTrendChartDataDto,
  TAnalysisTrendChartDataVo,
} from '../types';

import {
  isNonEmptyWireArray,
  normalizeTableDataList,
  pickChartDisplayMeta,
} from './common';

/** Trend · `chart_data` wire 是否无有效数据。 */
function isTrendChartWireNoData(
  value: TAnalysisTrendChartDataDto | null | undefined,
): boolean {
  if (!isNonEmptyWireArray(value)) {
    return true;
  }

  return value.every(item => item == null);
}

/** Trend · `chart_data` 二维数组同形透传；`null`/非数组兜底 `[]`。 */
function normalizeTrendChartData(
  value: TAnalysisTrendChartDataDto | null | undefined,
): TAnalysisTrendChartDataVo {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(item => item != null) as TAnalysisTrendChartDataVo;
}

export function transformTrendChartResponseDtoToVo(
  dto: IAnalysisTrendChartResponseDto,
): IAnalysisTrendChartResultVo {
  const {
    trend_metric: trendMetric,
    chart_data: lineDataWire,
    table_data: tableDataWire,
  } = dto;
  const isNoData = isTrendChartWireNoData(lineDataWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.Trend,
    isNoData,
    ...(isNoData
      ? {}
      : {
          trendMetric,
          lineData: normalizeTrendChartData(lineDataWire),
          tableData: normalizeTableDataList(tableDataWire),
        }),
  };
}
